import { useViewportSize } from '@mantine/hooks'
import { useTheme } from '@mui/material'

const useIdentifyViewportWidth = () => {
  const theme = useTheme()
  const { width: viewportWidth } = useViewportSize()
  const isExtraSmallScreen = viewportWidth < theme.breakpoints.values.sm
  const isSmallScreen =
    viewportWidth >= theme.breakpoints.values.sm &&
    viewportWidth < theme.breakpoints.values.md
  const isMediumScreen =
    viewportWidth >= theme.breakpoints.values.md &&
    viewportWidth < theme.breakpoints.values.lg
  const isLargeScreen =
    viewportWidth >= theme.breakpoints.values.lg &&
    viewportWidth < theme.breakpoints.values.xl
  const isExtraLargeScreen = viewportWidth >= theme.breakpoints.values.xl
  return {
    isExtraSmallScreen,
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isExtraLargeScreen,
  }
}

export default useIdentifyViewportWidth
